const flat_permissions = (user) => {
    const permission_groups = Object.keys(user.perms)
    const permissions_flat = permission_groups.flatMap(group => 
        user.perms[group].map(permission => `${group}.${permission}`)
    )
    return permissions_flat
}

export const hasPerm = defineAbility((user, perm) => {
    return flat_permissions(user).includes(perm)
})

export const hasAllPerm = defineAbility((user, perms) => {
    return perms.every(perm => flat_permissions(user).includes(perm))
})

export const hasAnyPerm = defineAbility((user, perms) => {
    return Array.isArray(perms) ? perms.some(perm => flat_permissions(user).includes(perm)) : false
})

export default {
    hasPerm,
    hasAllPerm,
    hasAnyPerm
}